export default __webpack_public_path__ + "static/media/476.5b849904.png";